/* eslint-disable react/prop-types */
import React, { useState } from "react";

import {
  ContainerMenuHamburguer,
  Block,
  HeaderButton,
  BackButtonContainer,
  SearchBarContainer,
  SearchInput,
} from "./styles";

import Cart from "../Cart";
import { IconContext } from "react-icons";
import { IoMdClose } from "react-icons/io";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { HiChevronLeft } from "react-icons/hi";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { useNavigate, useMatch } from "react-router";
import { useOpen } from "../../hooks/Open";
import { useUserData } from "../../hooks/UserContext";
import { useApp } from "../../contexts/AppContext";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import { useSearchVisibility } from "../../hooks/useSearchVisibility";
import notify from "../UI/toast";

function Header(props) {
  const { category, brands, closeAllMenu } = useOpen();
  const navigate = useNavigate();
  const { user } = useUserData();
  const { whitelabel } = useApp();
  const screenName = useScreenTracking();
  const [searchQuery, setSearchQuery] = useState("");

  const redirectHome = () => {
    trackClick({
      title: "logo-home",
      contentType: "header",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    closeAllMenu();
    navigate("/loja");
  };

  const handleGoBack = () => {
    trackClick({
      title: "botao-voltar",
      contentType: "header",
      screenName,
      tagId: tagIdFromLegacySuffix("01"),
    });
    closeAllMenu();
    navigate(-1);
  };

  const handleMenuToggle = () => {
    const isMenuOpen = props.open;
    const isInCategory = category || brands;

    if (isMenuOpen) {
      if (isInCategory) {
        trackClick({
          title: "voltar-categoria",
          contentType: "header",
          screenName,
          tagId: tagIdFromLegacySuffix("01"),
        });
        props.returnDiv();
      } else {
        trackClick({
          title: "fechar-menu",
          contentType: "header",
          screenName,
          tagId: tagIdFromLegacySuffix("01"),
        });
        props.sidebar();
      }
    } else {
      trackClick({
        title: "abrir-menu",
        contentType: "header",
        screenName,
        tagId: tagIdFromLegacySuffix("01"),
      });
      props.sidebar();
    }
  };

  const handleSearch = () => {
    if (searchQuery.length > 1) {
      trackClick({
        title: "buscar",
        contentType: "busca",
        screenName,
        tagId: tagIdFromLegacySuffix("12"),
      });
      navigate("/loja/products/" + searchQuery);
      setSearchQuery("");
    } else {
      notify("Digite pelo menos 2 caracteres no campo de busca", "error");
    }
  };

  // Rotas onde o botão voltar é oculto
  const isRouteHome = useMatch("/loja");
  const isRouteCheckoutTravelMessage = useMatch("/loja/checkout-message-travel/:id");
  const isRouteCheckoutTravelMessageNoId = useMatch("/loja/checkout-message-travel");
  const isRouteOrderResumeStatus = useMatch("/loja/orderresumestatus/:id");
  const isRouteOrderNotApproved = useMatch("/loja/ordernotapproved");
  const isRouteOrderPlaced = useMatch("/loja/orderplaced");
  const isRouteOrderPlacedSuccessfully = useMatch("/loja/orderplacedsuccessfully");

  const shouldHideBackButton =
    isRouteHome ||
    isRouteCheckoutTravelMessage ||
    isRouteCheckoutTravelMessageNoId ||
    isRouteOrderResumeStatus ||
    isRouteOrderNotApproved ||
    isRouteOrderPlaced ||
    isRouteOrderPlacedSuccessfully;

  // Rotas onde a busca é oculta
  const shouldShowSearch = useSearchVisibility();

  // Pontos visíveis quando payment_mode é "points" ou "both"
  const showPoints =
    whitelabel?.payment_mode === "points" ||
    whitelabel?.payment_mode === "both";

  return (
    <>
      <IconContext.Provider value={{ className: "custom-icon-wl" }}>
        <header
          className="header-wl"
          style={{ backgroundColor: whitelabel?.header_color }}
        >
          {/* Seção 1: Top Bar */}
          <Block className="header-top-bar">
            <div className="header-left">
              <img
                src={whitelabel?.logo_url}
                alt={whitelabel?.name}
                className="logo-wl"
                onClick={() => redirectHome()}
              />
            </div>
            <div className="header-right">
              <Cart />
              <ContainerMenuHamburguer>
                <HeaderButton type="button" onClick={handleMenuToggle}>
                  {props.open ? (
                    (props.open && category) || (props.open && brands) ? (
                      <HiChevronLeft className="return" />
                    ) : (
                      <IoMdClose />
                    )
                  ) : (
                    <HiOutlineMenuAlt3 />
                  )}
                </HeaderButton>
              </ContainerMenuHamburguer>
            </div>
          </Block>

          {/* Seção 2: Greeting Bar */}
          <Block
            className="d-flex justify-content-between align-items-center p-3 px-4"
            style={{
              color: whitelabel?.text_secondary_color,
              maxHeight: "57px",
              borderTop: "1px solid rgba(255, 255, 255, 0.3)",
            }}
          >
            {!shouldHideBackButton ? (
              <BackButtonContainer>
                <HeaderButton
                  type="button"
                  style={{
                    position: "relative",
                    right: "10px",
                  }}
                  onClick={handleGoBack}
                >
                  <HiChevronLeft />
                </HeaderButton>
                <span className="font-wl-500 text-md text-capitalize">
                  Olá, {user?.nome?.toLowerCase()}
                </span>
              </BackButtonContainer>
            ) : (
              <span className="font-wl-500 text-md text-capitalize">
                Olá, {user?.nome?.toLowerCase()}
              </span>
            )}
            {showPoints && (
              <span
                className="font-wl-700 text-mg"
                style={{ color: whitelabel?.text_secondary_color }}
              >
                {user?.balance?.data &&
                  Math.floor(user?.balance?.data).toLocaleString("pt-BR")}{" "}
                Pts
              </span>
            )}
          </Block>

          {/* Seção 3: Search Bar */}
          {shouldShowSearch && (
            <SearchBarContainer>
              <SearchInput>
                <MagnifyingGlass size={20} color="#595959" />
                <input
                  type="text"
                  placeholder={`Buscar no ${whitelabel?.name || "marketplace"}`}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </SearchInput>
            </SearchBarContainer>
          )}
        </header>
      </IconContext.Provider>
    </>
  );
}

export default Header;
